module.exports = __webpack_public_path__ + "img/download.baa752a6.png";